import { DateTime } from 'luxon';

export { settingsModuleName as moduleName } from '@shared/constants';

export const devices = Object.freeze({
  MOBILE: 'mobile',
  DESKTOP: 'desktop',
});

const cutoffDate = DateTime.fromObject({ year: 2026, month: 3, day: 15 });

const now = DateTime.now();

export const isDisableForumDay = now >= cutoffDate;
